/** The fixed set the AI text field's emoji picker offers: plain unicode, rendered by the browser. */
export const COMMON_EMOJIS: readonly string[] = [
  '😀',
  '😁',
  '😂',
  '🙂',
  '😊',
  '😍',
  '😎',
  '🤔',
  '😅',
  '😉',
  '😢',
  '😮',
  '🙌',
  '👍',
  '👎',
  '👏',
  '🙏',
  '💪',
  '✨',
  '🔥',
  '🎉',
  '✅',
  '❌',
  '⭐',
  '❤️',
  '💡',
  '📌',
  '📈',
  '📣',
  '🚀',
  '⏰',
  '💬',
];
